/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import { xhrPromise } from "../../../../utils/xhr";
var getAppConfigProperties = function getAppConfigProperties(_ref) {
  var envId = _ref.envId,
    serviceId = _ref.serviceId,
    toolchainId = _ref.toolchainId;
  var propertiesUrl = "/devops/pipelines/tekton/api/v1/appconfig/".concat(toolchainId, "/").concat(serviceId, "/properties?env_id=").concat(envId);
  return xhrPromise(propertiesUrl, {
    dataType: "json",
    method: "GET"
  });
};
var getAppConfigFeatures = function getAppConfigFeatures(_ref2) {
  var envId = _ref2.envId,
    serviceId = _ref2.serviceId,
    toolchainId = _ref2.toolchainId;
  var featuresUrl = "/devops/pipelines/tekton/api/v1/appconfig/".concat(toolchainId, "/").concat(serviceId, "/feature-flags?env_id=").concat(envId);
  return xhrPromise(featuresUrl, {
    dataType: "json",
    method: "GET"
  });
};
var getAppConfigResolvedVal = function getAppConfigResolvedVal(_ref3) {
  var appConfigString = _ref3.appConfigString,
    envId = _ref3.envId,
    toolchainId = _ref3.toolchainId;
  var resolveUrl = "/devops/pipelines/tekton/api/v1/appconfig/".concat(toolchainId, "/resolve?env_id=").concat(envId);
  return xhrPromise(resolveUrl, {
    body: {
      data: appConfigString
    },
    dataType: "json",
    method: "POST"
  });
};
export default {
  getAppConfigProperties: getAppConfigProperties,
  getAppConfigFeatures: getAppConfigFeatures,
  getAppConfigResolvedVal: getAppConfigResolvedVal
};